import React from "react";
import "./footer.css";

export function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* 1. oszlop */}
        <div className="footer-col">
          <h3>Elérhetőségek</h3>
          <p className="footer-highlight">Telefonszám:</p>
          <p>+36 30 182 7202</p>
          <p className="footer-highlight">E-mail cím:</p>
          <p>info@csaszartravel.hu</p>
          <p className="footer-highlight">Irodánk címe:</p>
          <p>8960 Lenti, Kossuth út 1.</p>
          <p className="footer-subinfo">
            <strong>Ügyfélszolgálatunk:</strong>
            <br />
            Hétköznapokon 9.00 és 17:00 között elérhető. 
            <br />
            <br />
            <strong>Irodánk Nyitvatartása:</strong><br /> Hétfő: 9.00-11.00<br></br> Szerda: 12.00-17.00<br></br> Csütörtök: 9.00-11.00
          </p>
        </div>

        {/* 2. oszlop */}
        <div className="footer-col">
          <h3>Császár Travel Kft.</h3>
          <p className="footer-highlight">Engedélyszám:</p>
          <p>U-002083</p>
          <p className="footer-highlight">Adószám:</p>
          <p>32765179-2-20</p>
          <p className="footer-highlight">Cégjegyzékszám:</p>
          <p>20-09-079589</p>
          <p className="footer-highlight">Székhely:</p>
          <p>
          8868 Murarátka, 
            <br />
            Hunyadi János utca 1.
          </p>
        </div>

        {/* 3. oszlop */}
        <div className="footer-col">
          <h3>Hasznos</h3>
          <ul className="footer-list">
            <li>
              <a href="/adatvedelmi_nyilatkozat">Adatvédelmi nyilatkozat</a>
            </li>
            <li>
              <a href="/aszf">ÁSZF</a>
            </li>
            <li>
              <a href="/jogi_nyilatkozat">Jogi nyilatkozat</a>
            </li>
          </ul>
          <h3>Kövess minket itt is!</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61574498204982" target="_blank" rel="noopener noreferrer">
              <img src="https://upload.wikimedia.org/wikipedia/commons/6/6c/Facebook_Logo_2023.png" style={{width: "30px"}} alt="Facebook" />
            </a>
          </div>
        </div>
      </div>

      {/* Alsó sáv */}
      <div className="footer-bottom">
        <p>🛡️Minden jog fenntartva © {new Date().getFullYear()}. csaszartravel.hu</p>
        <p>🔌 Powered by Webcsászár</p>
      </div>
    </footer>
  );
}
